import { render } from "./PropertyDefinitionModal.vue?vue&type=template&id=60757be2&scoped=true"
import script from "./PropertyDefinitionModal.vue?vue&type=script&lang=js"
export * from "./PropertyDefinitionModal.vue?vue&type=script&lang=js"

import "./PropertyDefinitionModal.vue?vue&type=style&index=0&id=60757be2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60757be2"

export default script